import {ApolloClient} from '@apollo/client';
import {useCallback, useEffect, useSyncExternalStore} from 'react';
import {toast} from 'sonner';
import {deactivationRunner, getCounts} from './deactivationRunner';

export const useBulkDeactivationRun = () =>
  useSyncExternalStore(
    deactivationRunner.subscribe,
    deactivationRunner.getSnapshot,
  );

export const useBulkDeactivationStatus = () => {
  const run = useBulkDeactivationRun();
  const counts = getCounts(run);

  return {
    counts,
    jobInFlight: !!run && !counts.isComplete,
    run,
  };
};

export const useBulkDeactivationActions = () => {
  const start = useCallback(
    (ids: string[]) => deactivationRunner.start(ids),
    [],
  );
  const dismiss = useCallback(() => deactivationRunner.dismiss(), []);

  return {dismiss, start};
};

export const useConfigureBulkDeactivation = (
  client: ApolloClient<object>,
  onComplete: () => void,
) => {
  useEffect(() => {
    deactivationRunner.setClient(client);
    deactivationRunner.setOnComplete(onComplete);
    deactivationRunner.setOnError(message => toast.error(message));
    deactivationRunner.resumeFromStorage();
  }, [client, onComplete]);
};
